<div style="overflow: scroll; max-height: calc(100svh - 350px);">
  <div class="p-fluid p-grid"
    style="padding-right: 15px">
    <div class="p-field p-col-5">
      <habil-label name="txtNome"
        label="Cliente">
        <input type="text"
          name="txtNome"
          pInputText
          [(ngModel)]="registro.nome" />
      </habil-label>
    </div>
    <div class="p-field p-col-2">
      <habil-label name="txtCnpj"
        label="CPF / CNPJ">
        <input type="text"
          name="txtCnpj"
          pInputText
          [(ngModel)]="registro.cnpj" />
      </habil-label>
    </div>
    <div class="p-field p-col-2">
      <habil-label name="ddSoftwares"
        label="Software">
        <p-dropdown name="ddSoftwares"
          optionValue="value"
          optionLabel="label"
          [disabled]="true"
          [(ngModel)]="licenca.software"
          [options]="softwares">
        </p-dropdown>
      </habil-label>
    </div>

    <div class="p-field p-col-2">
      <habil-label name="deVctoChave"
        label="Vencimento">
        <habil-date-edit name="deVctoChave"
          [(ngModel)]="obj.expDate"
          [disabled]="bloqueiaAlterarVencimento()">
        </habil-date-edit>
      </habil-label>
    </div>
    <div class="p-field p-col-1"
      *ngIf="permiteAlterarTrial() && (!bloqueiaAlterarVencimento() || !oldTrial)"
      [pTooltip]="tooltipNovoVencimento()">
      <habil-label name="inTrial"
        label="Dias Trial">
        <p-inputNumber style="max-height: 36px !important;"
          inputId="inTrial"
          [(ngModel)]="obj.trial"
          [showButtons]="true"
          [disabled]="oldTrial && bloqueiaAlterarVencimento()"
          [min]="0"
          [max]="5"
          suffix=" dias">
        </p-inputNumber>
      </habil-label>
    </div>
    <div class="p-field p-col-2">
      <habil-label name="inNroLicencas"
        label="Licenças">
        <p-inputNumber inputId="inNroLicencas"
          [(ngModel)]="obj.nroLicencas">
        </p-inputNumber>
      </habil-label>
    </div>
    <div class="p-field p-col-2">
      <habil-label name="inNroEmpresas"
        label="Empresas">
        <p-inputNumber inputId="inNroEmpresas"
          [(ngModel)]="obj.empresas">
        </p-inputNumber>
      </habil-label>
    </div>
    <div class="p-field p-col-2">
      <habil-label name="inNroBoletos"
        label="Boletos">
        <p-inputNumber inputId="inNroBoletos"
          [(ngModel)]="obj.boletos">
        </p-inputNumber>
      </habil-label>
    </div>
    <div class="p-field p-col-2 p-col-align-center">
      <br />
      <p-checkbox [binary]="true"
        [(ngModel)]="licenca.personalizada"
        label="Personalizar rotinas">
      </p-checkbox>
    </div>
    <div class="p-field p-col-12">
      <p-panel header="Emissões">
        <p-table [value]="obj.emissoes"
          [scrollable]="true"
          scrollDirection="both">
          <ng-template pTemplate="header">
            <tr>
              <th style="width: 80px">
                <p-button icon="pi pi-plus"
                  (onClick)="novaEmissao()"></p-button>
              </th>
              <th style="width: 200px">CNPJ</th>
              <th style="width: 80px">NF-e</th>
              <th style="width: 200px">Vencimento</th>
              <th style="width: 100px">Qtde</th>
              <th style="width: 80px">NFC-e</th>
              <th style="width: 200px">Vencimento</th>
              <th style="width: 100px">Qtde</th>
              <th style="width: 80px">NFS-e</th>
              <th style="width: 200px">Vencimento</th>
              <th style="width: 100px">Qtde</th>
              <th style="width: 80px">SAT</th>
              <th style="width: 200px">Vencimento</th>
              <th style="width: 100px">Qtde</th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body"
            let-product>
            <tr>
              <td style="width: 80px">
                <p-button icon="pi pi-trash"
                  (onClick)="apagaEmissao(product.documento)"></p-button>
              </td>
              <td style="width: 200px">
                <input pInputText
                  type="text"
                  [(ngModel)]="product.documento" />
              </td>
              <td style="width: 80px">
                <p-checkbox [binary]="true"
                  [(ngModel)]="product.nfe">
                </p-checkbox>
              </td>
              <td style="width: 200px">
                <habil-date-edit [(ngModel)]="product.vctoNfe"></habil-date-edit>
              </td>
              <td style="width: 100px">
                <p-inputNumber [(ngModel)]="product.qtdeDocsNfe">
                </p-inputNumber>
              </td>
              <td style="width: 80px">
                <p-checkbox [binary]="true"
                  [(ngModel)]="product.nfce">
                </p-checkbox>
              </td>
              <td style="width: 200px">
                <habil-date-edit [(ngModel)]="product.vctoNfce"></habil-date-edit>
              </td>
              <td style="width: 100px">
                <p-inputNumber [(ngModel)]="product.qtdeDocsNfce">
                </p-inputNumber>
              </td>
              <td style="width: 80px">
                <p-checkbox [binary]="true"
                  [(ngModel)]="product.nfs">
                </p-checkbox>
              </td>
              <td style="width: 200px">
                <habil-date-edit [(ngModel)]="product.vctoNfs"></habil-date-edit>
              </td>
              <td style="width: 100px">
                <p-inputNumber [(ngModel)]="product.qtdeDocsNfs">
                </p-inputNumber>
              </td>
              <td style="width: 80px">
                <p-checkbox [binary]="true"
                  [(ngModel)]="product.sat">
                </p-checkbox>
              </td>
              <td style="width: 200px">
                <habil-date-edit [(ngModel)]="product.vctoSat"></habil-date-edit>
              </td>
              <td style="width: 100px">
                <p-inputNumber [(ngModel)]="product.qtdeDocsSat">
                </p-inputNumber>
              </td>
            </tr>
          </ng-template>
        </p-table>
      </p-panel>
    </div>
    <div class="p-field p-col-12">
      <p-panel header="Módulos"
        [collapsed]="licenca.personalizada">
        <p-pickList sourceHeader="Módulos disponíveis"
          (onMoveToSource)="onChangeModulos()"
          (onMoveToTarget)="onChangeModulos()"
          (onMoveAllToTarget)="onChangeModulos()"
          (onMoveAllToSource)="onChangeModulos()"
          targetHeader="Módulos Licenciados"
          [responsive]="true"
          [sourceStyle]="{ height: '250px' }"
          [targetStyle]="{ height: '250px' }"
          [source]="modulosDisponiveis"
          [target]="licenca.modulosLicenciados"
          [dragdrop]="true"
          filterBy="descricaoModulo">
          <ng-template let-modulo
            pTemplate="item">
            <div *ngIf="modulo">{{ modulo.descricaoModulo }}</div>
          </ng-template>
        </p-pickList>
      </p-panel>
    </div>
    <div class="p-field p-col-12">
      <p-panel header="Rotinas"
        [toggleable]="true"
        [collapsed]="!licenca.personalizada">
        <p-pickList sourceHeader="Rotinas disponíveis"
          targetHeader="Rotinas habilitadas"
          [responsive]="true"
          [sourceStyle]="{ height: '250px' }"
          [targetStyle]="{ height: '250px' }"
          [source]="rotinas"
          [target]="rotinasComDescricao"
          [dragdrop]="true"
          filterBy="label">
          <ng-template let-rotina
            pTemplate="item">
            <div *ngIf="rotina?.label">{{ rotina.label }}</div>
            <div *ngIf="!rotina?.label && rotina?.value">
              {{ rotina.value }}
            </div>
            <div *ngIf="!rotina?.label && !rotina?.value">{{ rotina }}</div>
          </ng-template>
        </p-pickList>
      </p-panel>
    </div>
    <div class="p-field p-col-12">
      <p-panel header="Módulos Adicionais">
        <p-table [value]="obj.adicionais"
          responsiveLayout="scroll">
          <ng-template pTemplate="header">
            <tr>
              <th style="width: 80px">
                <p-button icon="pi pi-plus"
                  (onClick)="novoModulo()"></p-button>
              </th>
              <th>CNPJ</th>
              <th>Módulo</th>
              <th>Vencimento</th>
              <th>Licenças</th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body"
            let-product>
            <tr>
              <td style="width: 80px">
                <p-button icon="pi pi-trash"
                  (onClick)="apagaModulo(product)"></p-button>
              </td>
              <td>
                <input pInputText
                  type="text"
                  [(ngModel)]="product.documento" />
              </td>
              <td>
                <p-dropdown [options]="modulosAdicionais"
                  appendTo="body"
                  optionLabel="description"
                  optionValue="value"
                  [(ngModel)]="product.modulo"></p-dropdown>
              </td>
              <td>
                <habil-date-edit [(ngModel)]="product.vcto"></habil-date-edit>
              </td>
              <td>
                <p-inputNumber [(ngModel)]="product.licencas"> </p-inputNumber>
              </td>
            </tr>
          </ng-template>
        </p-table>
      </p-panel>
    </div>
  </div>
</div>

<hr />
<div class="p-grid">
  <div class="p-col-2">
    <button pButton
      type="button"
      style="width: 100%"
      class="p-button-outlined p-button-danger"
      label="Cancelar"
      icon="pi pi-times"
      (click)="cancelar()"></button>
  </div>
  <div class="p-col"></div>
  <div class="p-col-2"
    *ngIf="permiteAlterarTrial(true)">
    <button pButton
      type="button"
      style="width: 100%"
      class="p-button-success"
      [loading]="loading"
      label="Salvar"
      icon="pi pi-check"
      (click)="salvar()"></button>
  </div>
</div>